module.exports = __webpack_public_path__ + "static/media/success-message.b0be81c8.png";